module.exports = __webpack_public_path__ + "static/img/TUSCANY_PAINT.091be59.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TUSCANY_PAINT.jpg
// module id = YbTH
// module chunks = 0